import React from 'react';
import Cijfer from './Cijfer';

import ContentHeadline from './ContentHeadline'

function ContentCijfer({ cijfers })
{
  return (
    <div className="py-16">
      <ContentHeadline headline="WERKBAAN OOST IN CIJFERS" style={{ name: "Headline H2 Blue Center" }} />
      <div className="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
        {cijfers.map((cijfar) => (
          <Cijfer key={cijfar.id} {...cijfar} />
        ))}
      </div>
    </div>
  );
}

export default ContentCijfer;